import {LatLngTuple} from "leaflet";


interface IRes {
    center: LatLngTuple
    zoom: number
}
export function getCenterZoom(polygon: LatLngTuple[]): IRes {
    let max_lat = polygon[0][0]
    let min_lat = polygon[0][0]
    let max_lng = polygon[0][1]
    let min_lng = polygon[0][1]

    for (let el of polygon) {
        if (el[0] > max_lat) max_lat = el[0]
        if (el[0] < min_lat) min_lat = el[0]
        if (el[1] > max_lng) max_lng = el[1]
        if (el[1] < min_lng) min_lng = el[1]
    }

    const center = [(max_lat+min_lat)/2, (max_lng+min_lng)/2] as LatLngTuple

    // const max_distance = Math.max(max_lat-min_lat, max_lng,min_lng)

    return {center: center, zoom: 0}

}